/**
 * @deprecated Moved to ../../util/imageUtils
 */
export {
  DEFAULT_WIDTH_TO_HEIGHT_RATIO,
  generateSrcset,
  generateUrl,
  generateUrlFromContainerWidth,
  imageWidths,
} from "./imageUtils"

// svg source = <svg xmlns='http://www.w3.org/2000/svg' width='30' height='44'><rect width='30' height='44' style='fill: none' /></svg>
export const transparentPlaceholder =
    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSczMCcgaGVpZ2h0PSc0NCc+PHJlY3Qgd2lkdGg9JzMwJyBoZWlnaHQ9JzQ0JyBzdHlsZT0nZmlsbDogbm9uZScgLz48L3N2Zz4="
